import React from "react";

type SectionHeaderProps = React.ClassAttributes<HTMLDivElement> & React.HTMLAttributes<HTMLDivElement>

export default function SectionHeader({ children, className, ...props }: SectionHeaderProps) {
  return (
    <div className={`w-full relative bg- px-4 text-[#333] bg-light-10 py-2 border-b-[2px] border-solid ${className}`} {...props}>
      {children}


    </div>
  )
}